let { Text } = require('account-ui');
let formSignals = require('../../../../../../signals/form');
let css = require('./create-user.css');
let { cut } = require('../../../../../../helpers/utils');
let signals = require('../../../../../../signals/account/create-user');
let SCHEMES = require('../../../../../../helpers/scheme');

const SELECTOR_CREATE = cut(css.createBtn);

class CreateUser {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [SELECTOR_CREATE]: this.onCreateUser
            }
        };
    }

    onCreateUser () {
        this.$context.signal(signals.onCreateUserStub);
    }
}

module.exports = {
    constructor: CreateUser,
    children: [
        {
            name: 'email-input',
            component: Text,
            props: {
                placeholder: 'Создать по Email',
                signals: {
                    inputText: formSignals.inputAndValidateText,
                    blurText: formSignals.blurText
                },
                position: 'leftToRight',
                scheme: SCHEMES.email
            },
            watcher: {
                value: ['account', 'orders', 'createUser', 'input', 'email']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/orders-options/create-user/index.js